/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-lines */
export const ICONS_CONFIG = {
    A_Icon_Play: {
        viewBox: '0 0 40 40',
    },
    Exit: {
        viewBox: '0 0 24 24',
    },
    Express: {
        viewBox: '0 0 16 16',
    },
    Express_filled: {
        viewBox: '0 0 16 16',
    },
    'Footer-apple': {
        viewBox: '0 0 32 32',
    },
    'Footer-chat': {
        viewBox: '0 0 32 32',
    },
    'Footer-google-play': {
        viewBox: '0 0 32 32',
    },
    'Footer-huawei': {
        viewBox: '0 0 32 32',
    },
    'Footer-phone': {
        viewBox: '0 0 32 32',
    },
    'Footer-rustore': {
        viewBox: '0 0 32 32',
    },
    Max: {
        viewBox: '0 0 32 32',
    },
    NewCancel: {
        viewBox: '0 0 24 24',
    },
    NewUser: {
        viewBox: '0 0 44 44',
    },
    QR: {
        viewBox: '0 0 24 24',
    },
    Settings: {
        viewBox: '0 0 24 24',
    },
    'Telegram-xl': {
        viewBox: '0 0 32 32',
    },
    'Vk-xl': {
        viewBox: '0 0 32 32',
    },
    Youtube: {
        viewBox: '0 0 32 32',
    },
    'add-to-cart': {
        viewBox: '0 0 24 24',
    },
    'add-to-fav': {
        viewBox: '0 0 24 24',
    },
    'added-to-wish-list': {
        viewBox: '0 0 20 20',
    },
    'all-preferences': {
        viewBox: '0 0 24 24',
    },
    'arrow-24': {
        viewBox: '0 0 24 24',
    },
    'arrow-collapse': {
        viewBox: '0 0 24 24',
    },
    'arrow-forward': {
        viewBox: '0 0 16 16',
    },
    'arrow-m': {
        viewBox: '0 0 24 24',
    },
    'arrow-new': {
        viewBox: '0 0 24 24',
    },
    'arrow-play-sm': {
        viewBox: '0 0 16 16',
    },
    'arrow-right': {
        viewBox: '0 0 16 16',
    },
    'arrow-sm': {
        viewBox: '0 0 16 16',
    },
    'arrow-thin': {
        viewBox: '0 0 24 24',
    },
    'arrow-triangle': {
        viewBox: '0 0 16 16',
    },
    arrow: {
        viewBox: '0 0 24 24',
    },
    back: {
        viewBox: '0 0 20 20',
    },
    biodinamika: {
        viewBox: '0 0 20 20',
    },
    'bonuses-cart': {
        viewBox: '0 0 28 28',
    },
    'bonuses-payment': {
        viewBox: '0 0 28 28',
    },
    'bonuses-percent': {
        viewBox: '0 0 28 28',
    },
    'bonuses-ruble': {
        viewBox: '0 0 28 28',
    },
    bonuses: {
        viewBox: '0 0 25 24',
    },
    burger: {
        viewBox: '0 0 24 24',
    },
    calc: {
        viewBox: '0 0 20 20',
    },
    'calendar-check-fill': {
        viewBox: '0 0 24 24',
    },
    calendarArrow: {
        viewBox: '0 0 32 32',
    },
    'cards-view': {
        viewBox: '0 0 20 20',
    },
    cart: {
        viewBox: '0 0 24 24',
    },
    catalog: {
        viewBox: '0 0 24 24',
    },
    'check-button': {
        viewBox: '0 0 24 24',
    },
    'check-mark': {
        viewBox: '0 0 24 24',
    },
    check: {
        viewBox: '0 0 24 24',
    },
    'checkmark-colored': {
        viewBox: '0 0 20 20',
    },
    'checkmark-thin': {
        viewBox: '0 0 32 32',
    },
    checkmark: {
        viewBox: '0 0 11 8',
    },
    'checkout-address': {
        viewBox: '0 0 24 24',
    },
    'checkout-phone': {
        viewBox: '0 0 24 24',
    },
    'checkout-worktime': {
        viewBox: '0 0 24 24',
    },
    'chevron-left': {
        viewBox: '0 0 24 24',
    },
    'chevron-right': {
        viewBox: '0 0 24 24',
    },
    chevron: {
        viewBox: '0 0 24 24',
    },
    'classmates-logo': {
        viewBox: '0 0 40 40',
    },
    classmates: {
        viewBox: '0 0 24 24',
    },
    'clear-filter': {
        viewBox: '0 0 12 12',
    },
    clock: {
        viewBox: '0 0 24 24',
    },
    'close-m': {
        viewBox: '0 0 20 20',
    },
    'close-old': {
        viewBox: '0 0 8 8',
    },
    close: {
        viewBox: '0 0 24 24',
    },
    comment: {
        viewBox: '0 0 24 24',
    },
    compass: {
        viewBox: '0 0 24 24',
    },
    copy: {
        viewBox: '0 0 16 16',
    },
    'delete-new': {
        viewBox: '0 0 24 24',
    },
    delete: {
        viewBox: '0 0 24 24',
    },
    'doc-icon': {
        viewBox: '0 0 32 32',
    },
    'down-rounded': {
        viewBox: '0 0 24 24',
    },
    down: {
        viewBox: '0 0 24 24',
    },
    dude: {
        viewBox: '0 0 16 16',
    },
    'ecs-visual-icon': {
        viewBox: '0 0 16 16',
    },
    edit: {
        viewBox: '0 0 24 24',
    },
    'eye-off': {
        viewBox: '0 0 24 24',
    },
    eye: {
        viewBox: '0 0 24 24',
    },
    'favourite-fill': {
        viewBox: '0 0 24 24',
    },
    'favourite-new-filled': {
        viewBox: '0 0 24 24',
    },
    'favourite-new': {
        viewBox: '0 0 24 24',
    },
    favourite: {
        viewBox: '0 0 24 24',
    },
    'file-icon': {
        viewBox: '0 0 32 32',
    },
    'filter-icon': {
        viewBox: '0 0 24 24',
    },
    'filter-new': {
        viewBox: '0 0 24 24',
    },
    filter: {
        viewBox: '0 0 24 24',
    },
    fineandrare: {
        viewBox: '0 0 36 36',
    },
    'flash-off': {
        viewBox: '0 0 24 24',
    },
    'flash-on': {
        viewBox: '0 0 24 24',
    },
    forward: {
        viewBox: '0 0 20 20',
    },
    friend: {
        viewBox: '0 0 24 24',
    },
    'google-logo': {
        viewBox: '0 0 40 40',
    },
    'hint-new': {
        viewBox: '0 0 24 24',
    },
    hint: {
        viewBox: '0 0 24 24',
    },
    history: {
        viewBox: '0 0 24 24',
    },
    'home-legal-phone': {
        viewBox: '0 0 32 32',
    },
    'horizontal-view': {
        viewBox: '0 0 20 20',
    },
    'info-filled': {
        viewBox: '0 0 16 16',
    },
    'info-new-2': {
        viewBox: '0 0 24 24',
    },
    'info-new-light-stroke': {
        viewBox: '0 0 18 18',
    },
    'info-new': {
        viewBox: '0 0 20 20',
    },
    info: {
        viewBox: '0 0 20 20',
    },
    'jpg-icon': {
        viewBox: '0 0 32 32',
    },
    kosher: {
        viewBox: '0 0 20 20',
    },
    lightning: {
        viewBox: '0 0 24 24',
    },
    link: {
        viewBox: '0 0 24 24',
    },
    'list-pointed': {
        viewBox: '-3 -3 24 24',
    },
    'list-view': {
        viewBox: '0 0 20 20',
    },
    'location-placemark-new': {
        viewBox: '0 0 24 24',
    },
    'location-placemark': {
        viewBox: '0 0 24 24',
    },
    'location-reverse': {
        viewBox: '0 0 24 24',
    },
    location: {
        viewBox: '0 0 24 24',
    },
    'logo-simple-wine-sm': {
        viewBox: '0 0 94 18',
    },
    'logo-sm': {
        viewBox: '0 0 32 32',
    },
    logo: {
        viewBox: '0 0 157 24',
    },
    'mail-ru-logo': {
        viewBox: '0 0 40 40',
    },
    'map-pin-colored': {
        viewBox: '0 0 28 32',
    },
    'menu-apple': {
        viewBox: '0 0 32 32',
    },
    'menu-google-play': {
        viewBox: '0 0 32 32',
    },
    'menu-huawei': {
        viewBox: '0 0 32 32',
    },
    'menu-rustore': {
        viewBox: '0 0 32 32',
    },
    minus: {
        viewBox: '0 0 24 24',
    },
    natural: {
        viewBox: '0 0 20 20',
    },
    'no-image-new': {
        viewBox: '0 0 61 60',
    },
    'no-image': {
        viewBox: '0 0 120 120',
    },
    orange: {
        viewBox: '0 0 20 20',
    },
    organic: {
        viewBox: '0 0 30 30',
    },
    organika: {
        viewBox: '0 0 20 20',
    },
    'pagination-chevron': {
        viewBox: '0 0 24 24',
    },
    'pdf-icon': {
        viewBox: '0 0 32 32',
    },
    'pencil-outbox': {
        viewBox: '0 0 24 24',
    },
    pencil: {
        viewBox: '0 0 24 24',
    },
    'percent-online': {
        viewBox: '0 0 13 13',
    },
    'percent-shield': {
        viewBox: '0 0 25 24',
    },
    phone2: {
        viewBox: '0 0 24 24',
    },
    pin: {
        viewBox: '0 0 24 24',
    },
    'placemark-fill': {
        viewBox: '0 0 24 24',
    },
    'placemark-m': {
        viewBox: '0 0 20 20',
    },
    placemark: {
        viewBox: '0 0 24 24',
    },
    plus: {
        viewBox: '0 0 24 24',
    },
    'png-icon': {
        viewBox: '0 0 32 32',
    },
    'profile-circle': {
        viewBox: '0 0 72 72',
    },
    profile: {
        viewBox: '0 0 24 24',
    },
    'question-filled': {
        viewBox: '0 0 16 16',
    },
    'question-sm': {
        viewBox: '0 0 16 16',
    },
    question: {
        viewBox: '0 0 24 24',
    },
    route: {
        viewBox: '0 0 18 16',
    },
    'sale-sm': {
        viewBox: '0 0 20 20',
    },
    'search-cancel': {
        viewBox: '0 0 24 24',
    },
    'search-loader': {
        viewBox: '0 0 24 24',
    },
    search: {
        viewBox: '0 0 24 24',
    },
    'share-rounded': {
        viewBox: '0 0 24 24',
    },
    share: {
        viewBox: '0 0 24 24',
    },
    'shine-filled': {
        viewBox: '0 0 14 14',
    },
    shine: {
        viewBox: '0 0 24 24',
    },
    snippet_bonuses: {
        viewBox: '0 0 16 16',
    },
    'social-networks-attach': {
        viewBox: '0 0 24 24',
    },
    'sorting-icon': {
        viewBox: '0 0 10 18',
    },
    'sorting-select-chevron': {
        viewBox: '0 0 20 20',
    },
    'split-cart': {
        viewBox: '0 0 24 24',
    },
    star: {
        viewBox: '0 0 16 16',
    },
    star_filled: {
        viewBox: '0 0 10 10',
    },
    sustainable: {
        viewBox: '0 0 20 20',
    },
    telegram: {
        viewBox: '0 0 24 24',
    },
    'toggle-height': {
        viewBox: '0 0 40 8',
    },
    up: {
        viewBox: '0 0 24 24',
    },
    vegan: {
        viewBox: '0 0 20 20',
    },
    'vertical-view': {
        viewBox: '0 0 20 20',
    },
    'video-play': {
        viewBox: '0 0 48 48',
    },
    video: {
        viewBox: '0 0 25 24',
    },
    views: {
        viewBox: '0 0 20 21',
    },
    virtualization: {
        viewBox: '0 0 48 48',
    },
    'vk-logo': {
        viewBox: '0 0 40 40',
    },
    vk: {
        viewBox: '0 0 24 24',
    },
    'walking-human': {
        viewBox: '0 0 10 16',
    },
    waterdrop: {
        viewBox: '0 0 20 20',
    },
    watermelon: {
        viewBox: '0 0 24 24',
    },
    wishlist: {
        viewBox: '0 0 16 16',
    },
    'yandex-logo': {
        viewBox: '0 0 40 40',
    },
};
